<div class="security-section">
  <app-tabs
    (tabSelect)="currentSelectedTab = $event"
    [currentTab]="0"
    [appTabElements]="appTabElements"
  ></app-tabs>
  <div
    *ngIf="currentSelectedTab === 0"
    class="open-production-findings-section card container-fluid clsCardContainer"
  >
    <div *ngIf="loading" class="card-body text-center clsBodyLoader">
      <img
        alt=""
        class="clsImgCenterVertical"
        src="assets/images/icons/reload_big_pink.gif"
      />
    </div>
    <app-open-production-findings
      (securityFindingDialogClosed)="getLiveSecurityFindings()"
      [liveSecurityFindingsResponse]="liveSecurityFindingsResponse"
      *ngIf="!loading && liveSecurityFindingsResponse"
    ></app-open-production-findings>
  </div>

  <div
    *ngIf="currentSelectedTab === 1"
    class="card container-fluid clsCardContainer clsCardWidth"
  >
    <div *ngIf="loading" class="card-body text-center clsBodyLoader">
      <img
        alt=""
        class="clsImgCenterVertical"
        src="../../../assets/images/icons/reload_big_pink.gif"
      />
    </div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="table-responsive">
          <app-security-table-findings-comments
            *ngIf="tblData"
            [tblCols]="[
              'since',
              'last',
              'severity',
              'title',
              'appName',
              'platform',
              'actions'
            ]"
            [tblData]="tblData"
            (getFindingsComments)="getFindingsComments()"
          ></app-security-table-findings-comments>
        </div>
      </div>
    </div>
  </div>
</div>
